var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleStoreLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3075 7.20115C13.7926 7.56255 13.7926 8.37649 13.3379 8.73792L12.0579 9.46271L10.1611 7.96955L12.0626 6.50488L13.3075 7.20115Z",
    fill: "#FFC801"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0677 9.45567L12.0674 9.45539H12.0671L10.1593 7.97036L10.1587 7.9698L10.1584 7.97008L10.1576 7.96924L10.1508 7.97433L3.12549 13.3251V13.5487C3.12546 13.8441 3.19459 14.1592 3.4305 14.2686C3.74134 14.4127 4.19486 14.131 4.19486 14.131L12.0677 9.45567Z",
    fill: "#F93647"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1508 7.97453L3.12549 13.3253V2.50391L10.1491 7.97228L10.1508 7.97453Z",
    fill: "#00D3FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.12549 2.39564V2.50392L10.1491 7.97229L10.1508 7.97454L10.1576 7.96945L10.1581 7.96917L10.161 7.96692L12.0624 6.51328C12.0624 6.51328 5.9471 2.85726 4.17433 1.80285C4.09721 1.75698 3.9124 1.64062 3.6908 1.71319C3.42533 1.80015 3.12549 2.11594 3.12549 2.39564Z",
    fill: "#00EF77"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleStoreLogo);
export default __webpack_public_path__ + "static/media/GoogleStoreLogo.465e561db164179d7851360a8188c7d3.svg";
export { ForwardRef as ReactComponent };